import { render } from "./PlanAdd.vue?vue&type=template&id=530f78ec&scoped=true"
import script from "./PlanAdd.vue?vue&type=script&lang=js"
export * from "./PlanAdd.vue?vue&type=script&lang=js"

import "./PlanAdd.vue?vue&type=style&index=0&id=530f78ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530f78ec"]])

export default __exports__